import { SectionsInterface } from '../../field.interface';

export class SiteLayout {
	sections: SectionsInterface[] = [
		{
			title: 'Location',
			items: [
				[
					{
						cssClass: 'col-sm-12 addOnTable',
						type: 'static-table',
						options: {
							tempSol: true,
							header: [
								{ 
									label: 'Characteristic',
									cssClass: 'col-sm-3'
								},
								{ 
									label: 'Description',
									cssClass: 'col-sm-9'
								},
							],
							rows: [
								{
									cssClass: 'd-flex',
									cols: [
										{
											cssClass: 'col-sm-3',
											options: {
												path: 'InspectionReport.property.site.siteFeature.location.prominentLocation.locationDescriptionType',
												displayType: 'text',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											cssClass: 'col-sm-9',
											options: {
												path: 'InspectionReport.property.site.siteFeature.location.prominentLocationDescriptionDetails',
												displayType: 'text',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteFeature.location.ancillaryLocations',
							header: false,
							hideIfNoValue: true,
							columns: [
								{
									cssClass: 'col-md-3',
									options: {
										path: 'locationDescriptionType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-9',
									options: {
										path: 'InspectionReport.property.site.siteFeature.location.ancillaryLocationDescriptionDetails',
										isFullPath: true,
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Waterfront Site Improvements',
			items: [
				[
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteFeature.waterfrontSiteImprovements',
							hideIfNoValue: true,
							columns: [
								{
									cssClass: 'col-md-12',
									options: {
										path: 'waterfrontImprovementType',
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Views',
			items: [
				[
					{
						cssClass: 'col-sm-12 addOnTable',
						type: 'static-table',
						options: {
							tempSol: true,
							header: [
								{ 
									label: 'View',
									cssClass: 'col-sm-2'
								},
								{ 
									label: 'Quality',
									cssClass: 'col-sm-2'
								},
								{ 
									label: 'Rating',
									cssClass: 'col-sm-2'
								},
								{ 
									label: 'Description',
									cssClass: 'col-sm-6'
								}
							],
							rows: [
								{
									cssClass: 'd-flex',
									cols: [
										{
											cssClass: 'col-sm-2',
											options: {
												path: 'InspectionReport.property.site.siteFeature.view.prominentView.viewDescriptionType',
												displayType: 'text',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											cssClass: 'col-sm-2',
											options: {
												path: 'InspectionReport.property.site.siteFeature.view.prominentView.viewQuality',
												displayType: 'text',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											cssClass: 'col-sm-2',
											options: {
												path: 'InspectionReport.property.site.siteFeature.view.prominentView.viewRating',
												displayType: 'text',
												show: {
													value: true,
													label: false
												}
											}
										},
										{
											cssClass: 'col-sm-6',
											options: {
												path: 'InspectionReport.property.site.siteFeature.view.prominentViewDescriptionDetails',
												displayType: 'text',
												show: {
													value: true,
													label: false
												}
											}
										}
									]
								}
							]
						}
					},
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteFeature.view.ancillaryViews',
							header: false,
							hideIfNoValue: true,
							columns: [
								{
									cssClass: 'col-md-2',
									options: {
										path: 'viewDescriptionType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-2',
									colSpan: 2,
									options: {
										path: 'viewQuality',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-6',
									options: {
										path: 'InspectionReport.property.site.siteFeature.view.ancillaryViewDescriptionDetails',
										isFullPath: true,
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Adverse Site Conditions',
			items: [
				[
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteFeature.adverseSiteConditions',
							columns: [
								{
									cssClass: 'col-md-3',
									options: {
										path: 'adverseType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-3',
									options: {
										path: 'adverseRemediationType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-6',
									options: {
										path: 'descriptionAdverseSiteCondition',
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Site Improvements',
			items: [
				[
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteFeature.siteImprovements',
							columns: [
								{
									cssClass: 'col-md-3',
									options: {
										path: 'siteImprovementType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-9',
									options: {
										path: 'descriptionSiteImprovement',
										show: {
											label: false
										}
									}
								},
								{
									type: 'table',									
									cssClass: 'col-sm-12',
									options: {
										header: 'Inground Pool Concerns',
										path: 'ingroundPoolConcerns',
										columns: [
											{
												cssClass: 'col-md-3',
												options: {
													path: 'poolConcernType',
													show: {
														label: false
													}
												}
											},
											{
												cssClass: 'col-md-9',
												options: {
													path: 'descriptionPoolConcern',
													show: {
														label: false
													}
												}
											}
										]
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Non Residential Uses',
			items: [
				[
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteFeature.nonResidentialUses',
							columns: [
								{
									cssClass: 'col-md-3',
									options: {
										path: 'nonResidentialUseType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-9',
									options: {
										path: 'descriptionNonResidentialUse',
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Electricity',
			items: [
				[
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteUtility.electricalServices',
							columns: [
								{
									cssClass: 'col-md-2',
									options: {
										path: 'serviceType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-2',
									options: {
										path: 'offGridService',
										displayType: 'bool',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-2',
									options: {
										path: 'typicalIndicator',
										displayType: 'bool',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-6',
									options: {
										path: 'descriptionNoneTypical',
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Sewer',
			items: [
				[
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteUtility.sewerServices',
							columns: [
								{
									cssClass: 'col-md-2',
									options: {
										path: 'serviceType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-2',
									options: {
										path: 'typicalIndicator',
										displayType: 'bool',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-8',
									options: {
										path: 'descriptionNoneTypical',
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Water',
			items: [
				[
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteUtility.waterServices',
							columns: [
								{
									cssClass: 'col-md-2',
									options: {
										path: 'waterType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-2',
									options: {
										path: 'typicalIndicator',
										displayType: 'bool',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-8',
									options: {
										path: 'descriptionNoneTypical',
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Gas',
			items: [
				[
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.siteUtility.gasServices',
							columns: [
								{
									cssClass: 'col-md-2',
									options: {
										path: 'serviceType',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-2',
									options: {
										path: 'typicalIndicator',
										displayType: 'bool',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-8',
									options: {
										path: 'descriptionNoneTypical',
										show: {
											label: false
										}
									}
								}
							]
						}
					}
				]
			]
		},
		{
			title: 'Car Storages',
			items: [
				[
					{
						type: 'table',
						cssClass: 'col-sm-12',
						options: {
							path: 'InspectionReport.property.site.carStorages',
							columns: [
								{
									cssClass: 'col-md-3',
									options: {
										path: 'type',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-3',
									options: {
										path: 'spaceCount',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-3',
									options: {
										path: 'spaceArea',
										show: {
											label: false
										}
									}
								},
								{
									cssClass: 'col-md-3',
									options: {
										path: 'garageConversionIndicator',
										displayType: 'bool',
										show: {
											label: false
										}
									}
								},
								{
									type: 'table',									
									cssClass: 'col-sm-12',
									options: {
										header: 'Deficiencies',
										path: 'carStorageDeficiencies',
										columns: [
											{
												cssClass: 'col-md-3',
												options: {
													path: 'deficiencyName',
													show: {
														label: false
													}
												}
											},
											{
												cssClass: 'col-md-3',
												options: {
													path: 'deficiencyType',
													show: {
														label: false
													}
												}
											},
											{
												cssClass: 'col-md-3',
												options: {
													path: 'carStorageDeficiencySeverity',
													show: {
														label: false
													}
												}
											},
											{
												cssClass: 'col-md-3',
												options: {
													path: 'descriptionCarStorageDeficiency',
													show: {
														label: false
													}
												}
											}
										]
									}
								},
								{
									type: 'table',									
									cssClass: 'col-sm-12',
									options: {
										header: 'Updates',
										path: 'carStorageUpdates',
										columns: [
											{
												cssClass: 'col-md-3',
												options: {
													path: 'carStorageUpdatedComponent',
													show: {
														label: false
													}
												}
											},
											{
												cssClass: 'col-md-3',
												options: {
													path: 'carStorageUpdateType',
													show: {
														label: false
													}
												}
											},
											{
												cssClass: 'col-md-3',
												options: {
													path: 'carStorageUpdateTimeframe',
													show: {
														label: false
													}
												}
											},
											{
												cssClass: 'col-md-3',
												options: {
													path: 'carStorageUpdateDescription',
													show: {
														label: false
													}
												}
											}
										]
									}
								}
							]
						}
					}
				]
			]
		}
	];
}
